<div class="audio-recorder">
  <div class="flex-audio-cmd">
      <div class="flex-btn">
        @if (isRecording() || (contentStateService.isLiveTranscribing() && contentStateService.liveTranscriptionSource() === 'recorder')) {
          <app-recording-indicator [stream]="contentStateService.liveAudioStream()" (stopClick)="contentStateService.isLiveTranscribing() ? stopLiveTranscription() : stopRecordingAudio()" />
        } @else {
          @if (continueTranscriptionMode) {
            <button
              mat-icon-button
              [matTooltip]="canUseAI ? ('AudioRecorder.ContinueTranscription' | translate) : ('GenerateContent.NoAiAccessTooltip' | translate)"
              (click)="startLiveTranscription(false)"
              [disabled]="loading || !canUseAI || loadings.transcriber.live"
              [appAiRestrictedHover]="!canUseAI"
            >
              @if (loadings.transcriber.live) {
                <mat-spinner diameter="18"></mat-spinner>
              } @else {
                <mat-icon>speech_to_text</mat-icon>
              }
            </button>
          } @else {
            <div class="split-button-container" #splitButtonContainer>
              <button
                mat-flat-button
                class="split-button-main"
                [matTooltip]="
                  (latestRecordAction() === 'record-audio'
                    ? 'AudioPlay.Tooltip.RecordAudio'
                    : latestRecordAction() === 'transcribe-only'
                      ? 'AudioPlay.Tooltip.TranscribeOnly'
                      : 'AudioPlay.Tooltip.RecordAndTranscribe'
                  ) | translate
                "
                (click)="executeMainAction($event, splitButtonContainer)"
                [disabled]="loading || contentStateService.isLiveTranscribing() || loadings.transcriber.live || (latestRecordAction() !== 'record-audio' && !canUseAI)"
              >
                @if (loadings.transcriber.live && latestRecordAction() !== 'record-audio') {
                  <mat-spinner diameter="18" class="inline-spinner"></mat-spinner>
                } @else {
                  <mat-icon>{{ latestRecordAction() === 'record-audio' ? 'mic' : 'speech_to_text' }}</mat-icon>
                }
              </button>
              <button
                mat-flat-button
                class="split-button-trigger"
                [class.menu-open]="isMenuOpen()"
                #menuTrigger
                (click)="openSplitButtonMenu($event, splitButtonContainer)"
                [disabled]="loading || contentStateService.isLiveTranscribing() || loadings.transcriber.live"
              >
                <mat-icon>arrow_drop_down</mat-icon>
              </button>
            </div>
          }
        }
      </div>
      <audio #audioRecording></audio>
      @if (isRecording() || (contentStateService.isLiveTranscribing() && contentStateService.liveTranscriptionSource() === 'recorder')) {
        @if (!hideWaveform) {
          <app-live-waveform-display [@growShrink] [stream]="contentStateService.liveAudioStream()" />
        }
      } @else {
        @if (!continueTranscriptionMode && base64AudioData()) {
          @if (loadings.transcriber.recorded) {
            <app-transcription-progress-indicator [isActive]="true" />
          } @else {
            <app-audio-player
              #audioPlayerRef
              [@growShrink]
              [audioSource]="resolvedAudioUrl()"
              [additionalActions]="optionButtons"
              [audioSourceUpdating]="updatingAudioSource"
              [barsCount]="40"
              [barWidth]="4"
              [barGap]="2"
              [compact]="compact"
            />
          }
        }
      }
    </div>
</div>
